/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'hamburger-nav': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g _fill="currentColor" fill-rule="evenodd"><rect pid="0" y="2" width="16" height="2" rx="1"/><rect pid="1" y="7" width="16" height="2" rx="1"/><rect pid="2" y="12" width="16" height="2" rx="1"/></g>'
  }
})
